(ns dre.components.flash.events
  (:require
    [day8.re-frame.tracing :refer-macros [fn-traced]]
    [re-frame.core :as rf]))


(def db-path :flash)


;; -- Events

(rf/reg-event-fx
  ::show
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [{db :db} [content & {:keys [severity dismiss-after]
                          :or {severity :info}}]]
    {:pre [(#{:info :success :warning :error} severity)]}
    (let [id (hash content)]
      {:db (assoc db id {:id id
                         :content content
                         :severity severity
                         :timestamp (new js/Date)})
       :fx (cond-> []
             (pos-int? dismiss-after)
             (conj [:dispatch-later {:ms dismiss-after
                                     :dispatch [::dismiss id]}]))})))


(rf/reg-event-db
  ::dismiss
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [db [id]]
    (dissoc db id)))


(rf/reg-event-db
  ::dismiss-all
  [rf/trim-v]
  (fn-traced
    [db _]
    (dissoc db db-path)))


;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (db-path db)))


(rf/reg-sub
  ::messages
  :<- [::state]
  (fn [db _]
    (->> (vals db)
         (sort-by :timestamp)
         seq)))
